import React, { Component } from 'react';
import { findFlagUrlByIso3Code } from "country-flags-svg";
import PropTypes from 'prop-types';
import { flags } from './Switcher';

class LangItem extends Component {
    constructor(props) {
        super(props);
    }

    setLang = (e) => {
        this.props.activeLang(e.target.id);
    }

    render() {
        const {iso3Code, iso, lang} = this.props;
        const flagUrl = flags[iso3Code] || findFlagUrlByIso3Code(iso3Code);
        return(
            <div className='lang-item' onClick={this.setLang} id={iso}>
                <img src={flagUrl} alt={'iso'} referrerPolicy="no-referrer"/>
                {lang}
            </div>
        )
    }
}

export default LangItem;

LangItem.propTypes = {
    lang: PropTypes.string.isRequired,
    iso: PropTypes.string.isRequired,
    iso3Code: PropTypes.string.isRequired,
    activeLang: PropTypes.func.isRequired,
}